// These are endpoints for get/post/put methods

// TODO remove OpenAPI toggle code
export const ENDPOINT_PROGRAM = '/api/v4/core/programs/';
export const ENDPOINT_FUNDING_OPPORTUNITY = '/api/v4/core/funding-opportunities/';
export const ENDPOINT_CONFIGURATION = '/api/v4/core/config/';
export const ENDPOINT_ORGANIZATION = '/api/v4/core/organizations/';
export const ENDPOINT_ORGANIZATION_RELATIONSHIP =
  '/api/v4/core/organization-relationships/';
export const ENDPOINT_CLOSEOUT = '/api/v1/closeout/';
export const ENDPOINT_GRANT = '/api/v4/core/dynamicData/';
export const ENDPOINT_INVOICE = '/api/v4/finance/invoices/';
export const ENDPOINT_OBLIGATION = '/api/v4/finance/obligations/';
export const ENDPOINT_COMMITMENT = '/api/v4/finance/commitments/';
export const ENDPOINT_VENDOR = '/api/v4/finance/vendors/';
export const ENDPOINT_SSE = '/api/v2/sse/';
export const ENDPOINT_COMMENT = '/api/v4/core/comments/';
export const ENDPOINT_COMMUNITY = '/api/v4/core/community/';
export const ENDPOINT_ALLOCATION = '/api/v4/finance/allocations/';
export const ENDPOINT_ATTACHMENT = '/api/v4/core/attachments/';
export const ENDPOINT_HISTORY = '/api/v4/core/history/';
export const ENDPOINT_PANEL_REVIEW_APPLICATION = '/api/v1/panelreview/application/';
export const ENDPOINT_PANEL_REVIEW_SESSION = (sessionId) =>
  `/api/v1/panelreview/session/${sessionId}`;
export const ENDPOINT_PANEL_REVIEW_SCORES = '/api/v1/panelreview/scores/';
export const ENDPOINT_PANEL_REVIEW_CONFIG = '/api/v1/panelreview/config/';
export const ENDPOINT_PANEL_REVIEW_UPDATE_SUSPENDED_FLAG_REVIEWER_GROUP =
  '/api/v1/panelreview/updateSuspendedFlagForReviewerGroup/';
export const ENDPOINT_PANEL_REVIEW__GROUP_REVIEW = '/api/v1/panelreview/group/review/';
export const ENDPOINT_EHP = '/api/v4/ehp/';
//PanelV2 Endpoints
export const ENDPOINT_PANEL_V2 = '/api/v4/core/panelreview/';
export const ENDPOINT_PANEL_V2_SESSION = '/api/v4/core/panelreview/sessions/';
export const ENDPOINT_PANEL_V2_SESSIONS = '/api/v4/core/panelreview/sessions';
export const ENDPOINT_WORKFLOW = '/api/v4/workflow/';
export const ENDPOINT_WORKFLOW_TASK = '/api/v4/workflow/tasks/';
export const ENDPOINT_DYNAMIC_DATA = '/api/v4/core/dynamicData/';
export const ENDPOINT_RULES = '/api/v4/core/rules/';
export const ENDPOINT_TEMPLATES = '/api/v4/core/template/';
export const ENDPOINT_REFDATA = '/api/v4/core/ref/';
export const ENDPOINT_USER = '/api/v4/icam/user/'; ///users/';
export const ENDPOINT_SNAPSHOT = '/api/v4/core/snapshot/';
export const ENDPOINT_LOCATION = '/api/v4/core/locations/';
export const ENDPOINT_SEARCH = '/api/v4/core/dynamicData/entities/search';
export const ENDPOINT_ANALYTICS = '/api/v4/analytics/';
export const ENDPOINT_ACCOUNT = '/api/v2/account/';
export const ENDPOINT_ACCOUNT_V2 = '/api/v2/account/';
export const ENDPOINT_REGISTRATION = '/api/v2/registration/';

export const ENDPOINT_TRACKER = '/api/v4/core/trackers/';
export const ENDPOINT_TOGGLE = '/api/v4/core/config/toggles';
export const ENDPOINT_PRESCORE_V2 = '/api/v4/core/prescore';
export const ENDPOINT_DISASTER = '/api/v4/disaster/';

// if ENDPOINT_AUTH changes to bump the version, make a new one hardcoded to v1 so that /saml/ calls can use it these cannot change from v1
export const ENDPOINT_AUTH = '/api/v4/icam/token'; // see note
export const ENDPOINT_LOGIN_GOV = '/api/v4/icam/user/idp-users';
export const ENDPOINT_CAMUNDA = '/api/v1/camunda/';
export const ENDPOINT_KEYCLOAK =
  '/api/v4/keycloak/realms/femago/protocol/openid-connect/auth';
